import { groq } from '#imports';

export function getQuery() {
  return groq`*[_type == "engDonatePage" && !(_id in path('drafts.**'))][0]{
  content,
  titleImage,
  image,
  ogImage,
  seoTitle,
  seoDescription,
  lead,
  mediaCards[]->{
      link,
      logo,
    },
  }`;
}
